import React, { useState } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";


const Container = styled.div`
  position: relative;
  background: #160825;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
    position: relative;
`;

const NewRooms = styled.button`

  background-color: #A56EDC;
  border: none;
  width: 255px;
  height: 50px;
  border-radius: 10px 10px 10px 10px;
  text:"sds";
  margin: 0.5rem 0 0 0.5rem;
  cursor: pointer;
  color: white;
  font-family: Navilu,serif;

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

`;

// const Share = import React from 'react';
// () => {
//   return (
//     <svg
//       width="322"
//       height="50"
//       viewBox="0 0 322 50"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg">
//       <rect width="322" height="50" rx="10" fill="#382E43" />
//       <path
//         d="M46.4556 31.1037L46.2997 30.9478L46.1255 31.083C43.899 32.8116 41.0975 33.6266 38.2912 33.3622C35.4849 33.0978 32.8849 31.7739 31.0204 29.6599C29.156 27.546 28.1672 24.8009 28.2554 21.9836C28.3437 19.1663 29.5023 16.4885 31.4954 14.4954C33.4885 12.5023 36.1663 11.3437 38.9836 11.2554C41.8009 11.1672 44.546 12.156 46.6599 14.0204C48.7739 15.8849 50.0978 18.4849 50.3622 21.2912C50.6266 24.0975 49.8116 26.899 48.083 29.1255L47.9478 29.2997L48.1037 29.4556L53.3724 34.7243L53.3723 34.7244L53.3788 34.7304C53.4934 34.8372 53.5853 34.9659 53.649 35.109C53.7128 35.2521 53.7471 35.4065 53.7498 35.5631C53.7526 35.7197 53.7238 35.8753 53.6651 36.0205C53.6065 36.1657 53.5191 36.2976 53.4084 36.4084C53.2976 36.5191 53.1657 36.6065 53.0205 36.6651C52.8753 36.7238 52.7197 36.7526 52.5631 36.7498C52.4065 36.7471 52.2521 36.7128 52.109 36.649C51.9659 36.5853 51.8372 36.4934 51.7304 36.3788L51.7305 36.3787L51.7243 36.3724L46.4556 31.1037ZM47.4114 25.6771C47.851 24.6157 48.0773 23.4782 48.0773 22.3294C48.0773 20.0093 47.1557 17.7843 45.5151 16.1437C43.8746 14.5032 41.6495 13.5815 39.3294 13.5815C37.0093 13.5815 34.7843 14.5032 33.1437 16.1437C31.5032 17.7843 30.5815 20.0093 30.5815 22.3294C30.5815 23.4782 30.8078 24.6157 31.2474 25.6771C31.687 26.7384 32.3314 27.7028 33.1437 28.5151C33.956 29.3274 34.9204 29.9718 35.9817 30.4114C37.0431 30.851 38.1806 31.0773 39.3294 31.0773C40.4782 31.0773 41.6157 30.851 42.6771 30.4114C43.7384 29.9718 44.7028 29.3274 45.5151 28.5151C46.3274 27.7028 46.9718 26.7384 47.4114 25.6771Z"
//         fill="#BBBBBB"
//         stroke="#BBBBBB"
//         stroke-width="0.5"
//       />
//       <path
//         d="M82.1 33H79.9V18H91.3V33H89.1V19.8H82.1V33ZM99.1353 33.2C97.5886 33.2 96.3553 32.7 95.4353 31.7C94.5153 30.7 94.0553 29.46 94.0553 27.98C94.0553 26.5133 94.5153 25.2867 95.4353 24.3C96.3553 23.3 97.5886 22.8 99.1353 22.8C100.669 22.8 101.895 23.3 102.815 24.3C103.749 25.2867 104.215 26.5133 104.215 27.98C104.215 29.46 103.749 30.7 102.815 31.7C101.895 32.7 100.669 33.2 99.1353 33.2ZM96.8353 30.52C97.3686 31.1733 98.1353 31.5 99.1353 31.5C100.135 31.5 100.895 31.1733 101.415 30.52C101.949 29.8533 102.215 29.0067 102.215 27.98C102.215 26.98 101.949 26.1533 101.415 25.5C100.882 24.8333 100.122 24.5 99.1353 24.5C98.1486 24.5 97.3886 24.8333 96.8553 25.5C96.322 26.1533 96.0553 26.98 96.0553 27.98C96.0553 29.0067 96.3153 29.8533 96.8353 30.52ZM108.35 33H106.55V23H108.55V30.02L113.75 23H115.55V33H113.55V25.96L108.35 33ZM122.963 33.2C121.337 33.2 120.083 32.7067 119.203 31.72C118.323 30.7333 117.883 29.4867 117.883 27.98C117.883 26.5133 118.343 25.28 119.263 24.28C120.183 23.28 121.417 22.78 122.963 22.78C123.297 22.78 123.61 22.8 123.903 22.84C124.21 22.88 124.477 22.94 124.703 23.02C124.93 23.0867 125.143 23.1667 125.343 23.26C125.543 23.3533 125.71 23.4533 125.843 23.56C125.977 23.6533 126.097 23.7533 126.203 23.86C126.323 23.9533 126.417 24.0467 126.483 24.14C126.55 24.2333 126.603 24.32 126.643 24.4C126.697 24.4667 126.73 24.52 126.743 24.56L126.783 24.62V25.92H125.483L125.463 25.88C125.45 25.84 125.43 25.7933 125.403 25.74C125.377 25.6867 125.337 25.6267 125.283 25.56C125.243 25.48 125.19 25.4 125.123 25.32C125.057 25.24 124.977 25.16 124.883 25.08C124.79 25 124.677 24.9267 124.543 24.86C124.423 24.7933 124.283 24.7333 124.123 24.68C123.977 24.6133 123.803 24.5667 123.603 24.54C123.403 24.5 123.19 24.48 122.963 24.48C121.963 24.48 121.197 24.8133 120.663 25.48C120.143 26.1333 119.883 26.9667 119.883 27.98C119.883 29.0067 120.143 29.8533 120.663 30.52C121.197 31.1733 121.963 31.5 122.963 31.5C123.377 31.5 123.743 31.4533 124.063 31.36C124.397 31.2533 124.65 31.1333 124.823 31C124.997 30.8667 125.137 30.7267 125.243 30.58C125.35 30.42 125.417 30.3 125.443 30.22C125.483 30.14 125.503 30.0867 125.503 30.06H126.803V31.36C126.817 31.36 126.783 31.4267 126.703 31.56C126.637 31.68 126.517 31.8333 126.343 32.02C126.17 32.1933 125.943 32.3733 125.663 32.56C125.397 32.7333 125.023 32.88 124.543 33C124.063 33.1333 123.537 33.2 122.963 33.2ZM131.207 33H129.207V23H131.207V27.52L135.787 23H137.087V24.3L133.507 27.74L137.387 31.6V33H135.987L131.207 28.14V33ZM141.759 33H139.359V30.6H141.759V33ZM146.798 33H144.398V30.6H146.798V33ZM151.837 33H149.437V30.6H151.837V33Z"
//         fill="#BBBBBB"
//       />
//     </svg>
//   );
// };

const RoomsComponent = () => {

  const [roomList, setRoomList] = useState([]);
  const [count, setCount] = useState(0)
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  return (
    <Container>
      <Wrapper>
        <NewRooms clicked={click} onClick={() => handleClick()}>+ Новая комната</NewRooms>
      </Wrapper>
    </Container>
  );
};


export default RoomsComponent;